import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStarRounded = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.78263 2.7033C7.0761 2.10877 7.9239 2.10877 8.21737 2.7033L9.24529 4.78577C9.36173 5.02165 9.58667 5.18522 9.84696 5.22326L12.147 5.55944C12.8029 5.65532 13.0643 6.46159 12.5895 6.92412L10.9264 8.54391C10.7377 8.7277 10.6516 8.9926 10.6961 9.25223L11.0884 11.5396C11.2005 12.1932 10.5145 12.6915 9.92759 12.3829L7.87236 11.3021C7.63925 11.1795 7.36075 11.1795 7.12764 11.3021L5.07241 12.3829C4.4855 12.6915 3.79946 12.1932 3.91156 11.5396L4.30387 9.25223C4.3484 8.9926 4.26227 8.7277 4.07357 8.54391L2.41054 6.92412C1.93567 6.46159 2.1971 5.65532 2.85303 5.55944L5.15304 5.22326C5.41333 5.18522 5.63827 5.02165 5.75471 4.78577L6.78263 2.7033Z",
		fill: "currentColor",
		stroke: "currentColor",
		strokeWidth: 1.25,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgStarRounded;
